<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智慧社区轮播图 -->
    <CommunityBanner></CommunityBanner>
    <!-- 我们提供的技术支持 -->
    <TechnicalSupport></TechnicalSupport>
    <!-- 解决方案及架构 -->
    <Framework></Framework>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import CommunityBanner from '../../../../components/pc/Programme/CommunityComponents/CommunityBanner.vue'
import TechnicalSupport from '../../../../components/pc/Programme/CommunityComponents/TechnicalSupport.vue'
import Framework from '../../../../components/pc/Programme/CommunityComponents/Framework.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    CommunityBanner,
    TechnicalSupport,
    Framework,
  },
};
</script>

<style scoped>
</style>
